import * as _ from 'lodash-es';
import EnableSAMLIntegrationModal, {
  isSAMLIntegration,
} from './EnableSAMLIntegrationModal';
import EnableWithTokenModal, { usesStaticToken } from './EnableWithTokenModal';
import GitlabInstructionModal from './GitlabInstructionModal';
import ZendeskEnableModal from './ZendeskEnableModal';
import { UIActions } from '../../ui/uiSlice';
import request from '../../utils/network/request';
import type { NavigateFunction } from '../../utils/router/useNavigate';

const installIntegration = ({
  dispatch,
  feature,
  platform,
  redirectUrl,
  navigate,
}: {
  dispatch: (args: unknown) => void;
  feature?: string;
  platform: string;
  redirectUrl?: string;
  navigate?: NavigateFunction;
}) => {
  const props: { close?: () => void } = {};
  if (navigate) {
    props.close = () => {
      navigate('/admin/integrations');
      dispatch(UIActions.closeModal());
    };
  }
  if (usesStaticToken(platform)) {
    dispatch(
      UIActions.openModal(EnableWithTokenModal, {
        ...props,
        platform,
        redirectUrl,
      }),
    );
  } else if (isSAMLIntegration(platform)) {
    dispatch(
      UIActions.openModal(EnableSAMLIntegrationModal, {
        ...props,
        platform,
      }),
    );
  } else if (platform === 'gitlab') {
    dispatch(UIActions.openModal(GitlabInstructionModal, props));
  } else if (platform === 'zendesk') {
    dispatch(
      UIActions.openModal(ZendeskEnableModal, {
        ...props,
        redirectUrl: redirectUrl ?? null,
      }),
    );
  } else {
    const cloud = new URL(window.location.href).searchParams.get('cloud');
    const params = {
      redirect_url: redirectUrl,
      cloud,
    };
    const url = feature
      ? `/api/oauth2/feature/${platform}/${_.snakeCase(feature)}`
      : `/api/${platform}/integrate`;

    return request(url, 'GET', params)
      .then((data) => {
        document.location = (data as { url: string }).url.replace(
          '/authorizae',
          '/authorize',
        );
      })
      .catch(() => {
        dispatch(
          UIActions.pushToast({
            level: 'error',
            message: `Could not connect to ${_.capitalize(platform)}`,
          }),
        );
      });
  }

  return null;
};

export default installIntegration;
